import PrimaryNavigation from "./Footer";

export default PrimaryNavigation;
